import React, { useEffect, useState } from "react";
import { NotificationSummary } from "../../components";
import { NOTIFICATION_TYPE } from "../../types/enumerations/notifications";
var IncidentSummary = function (_a) {
    var countData = _a.countData;
    var _b = useState([]), subData = _b[0], setSubData = _b[1];
    var _c = useState({}), mainData = _c[0], setMainData = _c[1];
    useEffect(function () {
        var topCustCount = 0, restoredCount = 0, activeCount = 0;
        (countData || []).forEach(function (countItem) {
            var _a, _b, _c, _d, _e, _f;
            if (((_a = countItem === null || countItem === void 0 ? void 0 : countItem.name) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === "RESTORED") {
                restoredCount += ((_b = countItem === null || countItem === void 0 ? void 0 : countItem.count) !== null && _b !== void 0 ? _b : 0);
            }
            else if (((_c = countItem === null || countItem === void 0 ? void 0 : countItem.name) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === "TOP CUSTOMERS") {
                topCustCount += ((_d = countItem === null || countItem === void 0 ? void 0 : countItem.count) !== null && _d !== void 0 ? _d : 0);
            }
            else if (((_e = countItem === null || countItem === void 0 ? void 0 : countItem.name) === null || _e === void 0 ? void 0 : _e.toUpperCase()) === "ACTIVE") {
                activeCount += ((_f = countItem === null || countItem === void 0 ? void 0 : countItem.count) !== null && _f !== void 0 ? _f : 0);
            }
        });
        var mainDataObj = { title: "Active", value: activeCount };
        var subDataArray = [{ title: "Top customers", value: topCustCount }, { title: "Restored", value: restoredCount }, { title: "", value: "" }];
        setSubData(subDataArray);
        setMainData(mainDataObj);
    }, [countData]);
    return React.createElement(NotificationSummary, { notificationType: NOTIFICATION_TYPE.INCIDENTS, subData: subData, mainData: mainData });
};
export default IncidentSummary;
//# sourceMappingURL=index.js.map